export class QuadraDetalhesDto {
  id: number;
  label: string;
  coords: number[][];
  centro: number[];
  cidade: string;
}
